<footer class="mt-8 w-full border-t border-[#e5e5e5] px-6 py-4">
  <div
    class="flex flex-col lg:flex-row justify-between items-center gap-2 text-center">
    <p class="font-semibold text-[#808080] text-xs leading-5">
      <a
        target="_blank"
        [href]="configurationService.configuration.termsAndConditionsUrl">
        Terms of Service
      </a>
      <span class="mx-2">|</span>
      <a
        target="_blank"
        [href]="configurationService.configuration.termsOfUseUrl">
        Privacy Policy
      </a>
    </p>
    <p class="font-semibold text-[#808080] text-xs leading-5">
      &copy; {{ currentYear }}
      {{ configurationService.configuration.clientName }}. All rights reserved
    </p>
    <p class="font-semibold text-[#808080] text-xs leading-5">
      Powered by 3D Digital Venue.
    </p>
  </div>
</footer>
